import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import HistoricalShipmentList from "../../components/historical-shipment-list";
import ImportIcon from "../../globalStyles/icons/importIcon";
import { historicalShipmentService } from "../../utils/services/historical-shipments.service";
import { buildQueryObject } from "../../utils/query-builder";
import { hoistoricalShipmentFilterInitialState } from "../../utils/filter-config";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state.columns.map((x) =>
          x.key === action.payload.key ? { ...x, ...action.payload } : x
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    case "EXISTING_DATA":
      return {
        ...state,
        columns: state.columns.map((x) => ({
          ...x,
          filter:
            action.data.filters.find((y) => y.key === x.key)?.values ||
            x.filter,
        })),
        limit: action.data.limit || state.limit,
      };

    default:
      return state;
  }
}
const HistoricalShipments = () => {
  const [filterData, dispatch] = useReducer(
    filterReducer,
    hoistoricalShipmentFilterInitialState
  );
  const [historicalShipments, setHistoricalShipments] = useState([]);
  const [viewMode, setViewMode] = useState("list");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const clientId = localStorage.getItem("client_id");
  const navigate = useNavigate();
  const theme = useTheme();
  const text_color = theme?.palette?.text?.primary || "#FFF";
  const [selectedShipment, setSelectedShipment] = useState(null);
  const roles = JSON.parse(localStorage.getItem("roles")) || [];

  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;

  const fetchHistoricalOrders = async () => {
    setLoading(true);
    try {
      const response = await historicalShipmentService.filter(
        buildQueryObject(filterData, page)
      );
      setHistoricalShipments(response.data);
      setLoading(false);
      setDataCount(response.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchHistoricalOrders();
  }, [page, rowsPerPage, filterData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        hideAddButton
        header={"Historical Shipments"}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchHistoricalOrders()}
        headerButtons={
          roles.find((x) =>
            ["Client - Standard", "Client - Premium"].includes(x.name)
          ) ? (
            <>
              <Button
                size="small"
                style={{
                  textTransform: "none",
                  marginRight: 10,
                }}
                variant="contained"
                color="primary"
                onClick={() => {
                  navigate("/shipment-import");
                }}
              >
                <ImportIcon fill={"#ffff"} />
                <Typography
                  fontSize="14px"
                  fontWeight={500}
                  sx={{
                    color: text_color,
                    marginLeft: 1,
                  }}
                  fontFamily={"poppins"}
                >
                  Import
                </Typography>
              </Button>
            </>
          ) : (
            <></>
          )
        }
      >
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <HistoricalShipmentList
            dataCount={dataCount}
            page={page}
            rowsPerPage={filterData.limit}
            setRowsPerPage={(e) =>
              dispatch({
                type: "UPDATE_LIMIT",
                payload: e,
              })
            }
            setPage={setPage}
            onDeleteData={fetchHistoricalOrders}
            data={historicalShipments}
            viewMode={viewMode}
            selectedShipment={selectedShipment}
            setSelectedShipment={setSelectedShipment}
            clientId={clientId}
            onChangeFilter={handleFilterChange}
            filterData={filterData}
          />
        )}
      </DashboardContainer>
    </>
  );
};

export default HistoricalShipments;
